import React from "react";
import { Printer } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { API } from "@/lib/apiClient";

/**
 * LabelDialog — extracted from /pages/warehouse/Warehouses.jsx (iter47 refactor).
 * Renders + prints a QR label for a warehouse item.
 * Uses safe DOM-building (not innerHTML) to avoid XSS from user-supplied item names.
 */
export default function LabelDialog({ item, onClose, warehouses }) {
  if (!item) return null;
  const wh = warehouses.find((w) => w.id === item.warehouse_id);
  const labelUrl = `${API}/warehouse-items/${item.id}/label.png`;
  const printLabel = () => {
    const w = window.open("", "_blank", "width=400,height=300");
    if (!w) return;
    const doc = w.document;
    doc.title = `Label · ${item.sku || item.name || ""}`;
    doc.body.style.margin = "0";
    doc.body.style.fontFamily = "sans-serif";
    const box = doc.createElement("div");
    box.style.cssText = "padding:8mm;text-align:center;border:2px solid #0F172A;";
    const img = doc.createElement("img");
    img.src = labelUrl;
    img.alt = "QR";
    img.style.cssText = "width:120px;height:120px;display:block;margin:0 auto";
    const sku = doc.createElement("div");
    sku.style.cssText = "font-size:12px;font-weight:700;letter-spacing:0.15em;margin-top:6px";
    sku.textContent = item.sku || item.name || "";
    const name = doc.createElement("div");
    name.style.cssText = "font-size:10px;color:#475569;margin-top:2px";
    name.textContent = item.name || "";
    const meta = doc.createElement("div");
    meta.style.cssText = "font-size:9px;color:#94A3B8;margin-top:2px;text-transform:uppercase;letter-spacing:0.15em";
    meta.textContent = `${wh?.code || ""} · Celsius`;
    box.append(img, sku, name, meta);
    doc.body.append(box);
    img.addEventListener("load", () => w.print());
    img.addEventListener("error", () => w.print());
  };
  return (
    <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle className="font-display">QR Label · {item.name}</DialogTitle></DialogHeader>
        <div className="text-center py-4 border border-slate-200 rounded-sm">
          <img src={labelUrl} alt="QR" style={{ width: 200, height: 200 }} className="mx-auto" />
          <div className="text-sm font-bold mt-2 font-mono tracking-widest">{item.sku || item.name}</div>
          <div className="text-xs text-slate-500">{item.name}</div>
          <div className="text-[10px] text-slate-400 uppercase tracking-widest mt-1">{wh?.code || ""} · Celsius</div>
        </div>
        <Button onClick={printLabel} data-testid="print-label-btn" className="rounded-sm bg-[#EA580C] hover:bg-[#c2410c]"><Printer size={14} className="mr-1" /> Print Label</Button>
      </DialogContent>
    </Dialog>
  );
}
